import { Popup } from "./class";


const popup = new Popup(".form-popap", {
  openButtons: ".sign-up-link",
  closeButton: ".close-btn",
  on: {
    close() {
      this.element
        .querySelectorAll("input")
        .forEach((input) => input.removeAttribute("error"));
      this.element.querySelector(".form-thank")?.removeAttribute("show");
    },
  },
});

export default function openForm() {
  popup.open.bind(popup)();
}